// extracted by mini-css-extract-plugin
module.exports = {"paper":"styles_paper__3HYTR","input":"styles_input__1NA7s","iconButton":"styles_iconButton__3mJhs","searchIcon":"styles_searchIcon__3GnKW"};